var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    {
      attrs: {
        closeOnClickOutside: _vm.closeOnClickOutside,
        isOpen: _vm.isOpen
      },
      on: { "update:isOpen": _vm.handleUpdateIsOpen }
    },
    [
      _c("div", { staticClass: "cancel-dialog" }, [
        _c("img", {
          attrs: {
            width: "72",
            height: "72",
            src: require("@static/img/cancel.svg"),
            alt: "Cancel"
          }
        }),
        _c("div", { staticClass: "title", attrs: { "data-testid": "title" } }, [
          _vm._v("Confirm Payment Cancellation")
        ]),
        _c(
          "div",
          { staticClass: "message", attrs: { "data-testid": "message" } },
          [_vm._v("Do you want to cancel transaction?")]
        ),
        _c(
          "div",
          { staticClass: "buttons d-flex" },
          [
            _c(
              "EpButton",
              {
                staticClass: "confirm-button",
                on: {
                  click: function($event) {
                    return _vm.$emit("confirm")
                  }
                }
              },
              [_vm._v("Confirm")]
            ),
            _c(
              "EpButton",
              {
                staticClass: "discard-button",
                attrs: { variant: "outlined", color: "secondary" },
                on: {
                  click: function($event) {
                    return _vm.$emit("discard")
                  }
                }
              },
              [_vm._v(" Discard ")]
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }